import { DRAWER_CONTENT_EXCEPTION } from "../constants";
import { getTenantDomain } from "../helpers/tenantConfig";
import { getQaConsoleErrors } from "./qaConsole";

// Section = the sidebar nav label for the current route (the app's own nav
// definitions are the source of truth). Falls back to a heading inside <main>.
const findSection = (pathname) => {
  for (const item of DRAWER_CONTENT_EXCEPTION) {
    for (const sub of item?.toolTipElements || []) {
      if (sub?.toolTipPath && (pathname === sub.toolTipPath || pathname.startsWith(sub.toolTipPath + "/"))) {
        return sub?.title ? `${item.text} > ${sub.title}` : item.text;
      }
    }
    if (item?.path && (pathname === item.path || pathname.startsWith(item.path + "/"))) {
      return item.text;
    }
  }
  const heading = document.querySelector("main h1, main h2");
  return heading?.textContent?.trim()?.slice(0, 80) || "";
};

// Tab = the active sub-tab, marked aria-current="page" by the Tabs component.
// Scoped under <main> so the sidebar's own active marker can never leak in.
const findTab = () => {
  const main = document.querySelector("main");
  if (!main) return "";
  const marked = main.querySelectorAll('[aria-current="page"]');
  if (!marked.length) return "";
  return (marked[0].textContent || "").trim().slice(0, 80);
};

const findBuildHash = () => {
  const scripts = Array.from(document.querySelectorAll("script[src]"));
  for (const script of scripts) {
    const match = (script.src || "").match(/main\.([0-9a-f]+)\.js/);
    if (match) return match[1];
  }
  return "";
};

const parseUserAgent = () => {
  const ua = navigator.userAgent || "";
  let browser = "Unknown";
  if (/edg\//i.test(ua)) browser = "Edge";
  else if (/opr\//i.test(ua)) browser = "Opera";
  else if (/chrome\//i.test(ua)) browser = "Chrome";
  else if (/safari\//i.test(ua) && /version\//i.test(ua)) browser = "Safari";
  else if (/firefox\//i.test(ua)) browser = "Firefox";
  let platform = "Unknown";
  if (/windows/i.test(ua)) platform = "Windows";
  else if (/mac os x/i.test(ua)) platform = "macOS";
  else if (/android/i.test(ua)) platform = "Android";
  else if (/iphone|ipad|ipod/i.test(ua)) platform = "iOS";
  else if (/linux/i.test(ua)) platform = "Linux";
  const device = /mobi|android|iphone|ipad/i.test(ua) ? "Mobile" : "Desktop";
  return { browser, platform, device };
};

export const captureQaContext = () => {
  const { browser, platform, device } = parseUserAgent();
  const pathname = window.location.pathname;
  return {
    section: findSection(pathname),
    tab: findTab(),
    route: pathname + window.location.search + window.location.hash,
    tenant: getTenantDomain() || "",
    env: (process.env.REACT_APP_GATEWAY || "").includes("webstaging") ? "staging" : "prod",
    build: findBuildHash(),
    viewport: `${window.innerWidth}x${window.innerHeight}`,
    screen: `${window.screen?.width || 0}x${window.screen?.height || 0}`,
    dpr: window.devicePixelRatio || 1,
    browser,
    platform,
    device,
    language: navigator.language || "",
    timezone: (() => {
      try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone || "";
      } catch (e) {
        return "";
      }
    })(),
    captured_at: new Date().toISOString(),
    console_errors: getQaConsoleErrors(),
    ua: (navigator.userAgent || "").slice(0, 300),
  };
};
